import React from "react";
import "./Footer.css";

export default function Footer({
  services = [
    "Oil Changes",
    "Diagnostics",
    "Steering & Suspension",
    "Brakes",
    "DOT Inspections",
    "Prepurchase Inspections",
    "Used Car Safety Inspections",
    "Timing Belts",
    "Timing Chains",
    "Air Conditioning",
    "Transmissions",
    "Engines",
    "Mobile Services",
    "Drop Off Services",
    "Tune Ups",
  ],
  phone = "(253) 319-2612",
  cityState = "Puyallup, WA",
  logoSrc = "./logoservice.png",
  year = new Date().getFullYear(),
  brand = "Dempsey Mobile Service",
  privacyHref = "/privacy-policy",
  termsHref = "/terms-and-conditions",
  companyBlurb = "Hands-on mobile repair and fleet workshops that keep your vehicles safe, compliant, and ready for the road every day.",
}) {
  return (
    <footer className="footer" aria-labelledby="footer-heading">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-content">
          {/* Brand Section */}
          <section className="footer-brand">
            <h2 className="footer-brand-title">{brand}</h2>
            <div className="footer-logo">
              <img src={logoSrc} alt={`${brand} logo`} />
            </div>
            <p className="footer-description">{companyBlurb}</p>
          </section>

          {/* Services */}
          <section className="footer-section">
            <h3 className="footer-section-title">Our Services</h3>
            <ul className="footer-links">
              {services.map((service, i) => (
                <li key={i} className="footer-link-item">
                  {service}
                </li>
              ))}
            </ul>
          </section>

          {/* Contact */}
          <section className="footer-section">
            <h3 className="footer-section-title">Contact Info</h3>
            <ul className="footer-links">
              <li className="footer-link-item">
                <a href={`tel:${phone.replace(/\D/g, "")}`} className="footer-link">
                  {phone}
                </a>
              </li>
              <li className="footer-link-item">{cityState}</li>
            </ul>
          </section>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-legal">
            <div className="footer-legal-links">
              <a href={privacyHref} className="footer-legal-link">
                Privacy Policy
              </a>
              <span className="footer-separator">|</span>
              <a href={termsHref} className="footer-legal-link">
                Terms & Conditions
              </a>
              <span className="footer-separator">|</span>
              <a href="https://connectrader.com/" className="footer-legal-link">
                Site by connectrader
              </a>
            </div>
            <p className="footer-copyright">
              Copyright © {year} {brand}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}